import type { IAuthService, IService } from '@/services'
import {
	ClientService,
	CommonService,
	type Configuration,
	EntraIDAuthService,
	EventService,
	ForecastService,
	JobService,
	MicrosoftGraphService,
	NotificationService,
	ProductionService,
	QuoteService,
	ScenarioSubJobService,
	SiteCapacityService,
	SubJobService
} from '@/services'

export class DataServiceFactory {
	static authService: IAuthService
	static createAuthService(serviceType: string, config: Configuration): IAuthService {
		switch (serviceType) {
			case 'EntraIDAuth':
				if (DataServiceFactory.authService == null) {
					DataServiceFactory.authService = new EntraIDAuthService(config)
				}
				return DataServiceFactory.authService as EntraIDAuthService
			default:
				throw new Error(`Unknown service type: ${serviceType}`)
		}
	}
	static createService(
		serviceType:
			| 'Client'
			| 'Common'
			| 'Notification'
			| 'MicrosoftGraph'
			| 'Event'
			| 'Job'
			| 'SubJob'
			| 'Forecast'
			| 'ScenarioSubJob'
			| 'Production'
			| 'Quote'
			| 'SiteCapacity',
		authService: IAuthService
	): IService {
		switch (serviceType) {
			case 'Client':
				return new ClientService(authService)
			case 'Event':
				return new EventService(authService)
			case 'Job':
				return new JobService(authService)
			case 'ScenarioSubJob':
				return new ScenarioSubJobService(authService)
			case 'SubJob':
				return new SubJobService(authService)
			case 'Forecast':
				return new ForecastService(authService)
			case 'SiteCapacity':
				return new SiteCapacityService(authService)
			case 'Production':
				return new ProductionService(authService)
			case 'Quote':
				return new QuoteService(authService)
			case 'Common':
				return new CommonService(authService)
			case 'Notification':
				return new NotificationService(authService)
			case 'MicrosoftGraph':
				return new MicrosoftGraphService(authService)
			default:
				throw new Error(`Unknown service type: ${serviceType}`)
		}
	}
}

export {
	ClientService,
	CommonService,
	EntraIDAuthService,
	EventService,
	ForecastService,
	JobService,
	MicrosoftGraphService,
	NotificationService,
	ProductionService,
	QuoteService,
	ScenarioSubJobService,
	SiteCapacityService,
	SubJobService
}
